export default "__VITE_ASSET__CWxEON8x__"